<template>
    <div class="tc-scroll-up-anchor">
        <div class="tc-scroll-up"
             @click="$emit('click')">
            <SVGScrollUp/>
        </div>
    </div>
</template>

<script>
import SVGScrollUp from '@/UI/SVG/SVGScrollUp.vue';

export default {
    name: 'ScrollUp',
    components: { SVGScrollUp },
    emits: [
        'click',
    ],
};
</script>

<style scoped lang="scss">
.tc-scroll-up-anchor {
    position: fixed;
    width: 0;
    height: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    bottom: 20px;
    right: 20px;
}

.tc-scroll-up {
    position: relative;
    width: 30px;
    height: 30px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    user-select: none;
    color: #ffffff;
    background-color: #00458D;
    transition: 0.3s ease all;
}

.tc-scroll-up:hover {
    //color: #00458D;
    //background-color: #ffffff;
    color: #ffffff;
    background-color: #F58214;
}

.tc-scroll-up:active {
    box-shadow:none;
}

</style>
